import { CheckboxMapping, EndpointData, Locale } from '../types'
import type { LogoFlags, MissingTranslation } from '../components'
import request from '../../../services/request'
import { isChecked } from './helpers'
import { SetStateAction } from 'react'
import { downloadFiles } from '../services'

const DOWNLOAD_URL = '/api/extension/v1/files/certificates/ownership/self_redeemed/pdf'

export const downloadCertificateOwnershipSelfRedeemed = async (
    id: number,
    locale: Locale,
    isGradientCheckboxMappings: CheckboxMapping[],
    setMissingTranslations: (value: SetStateAction<MissingTranslation[]>) => void,
    setTranslationModalVisible: (value: SetStateAction<boolean>) => void,
    logoFlags?: LogoFlags,
): Promise<void> => {
    const isGradient = isChecked(isGradientCheckboxMappings, id)
    const endpoints: EndpointData[] = [
        {
            url: DOWNLOAD_URL,
            defaultExt: 'pdf',
            mime: 'application/pdf',
            withLogoParam: logoFlags?.client_logo ?? false,
            mainLogoId: logoFlags?.main_logo_id,
            isGradient: isGradient,
        },
    ]

    await downloadFiles(endpoints, id, locale, setMissingTranslations, setTranslationModalVisible)
}

export const collectOwnershipErrors = async (id: number, locale: Locale) => {
    const userMissing: string[] = []
    let operatorError = false

    try {
        await request.get(DOWNLOAD_URL, {
            params: { certificate_id: id, locale },
            responseType: 'blob',
        })
    } catch (err: any) {
        const res = JSON.parse(await err.text())
        if (res?.detail?.user_errors?.length > 0 && locale === 'en') {
            const text_data: string[] = await res.detail.user_errors
            if (text_data) {
                userMissing.push(...text_data)
            }
        } else if (res?.detail?.operator_errors?.length > 0 && locale === 'en') {
            operatorError = true
        }
    }

    return { userMissing: [...new Set(userMissing)], operatorError }
}
